/* eslint-disable jsx-a11y/anchor-is-valid */

import * as React from "react";
import {getContainer} from "../../ioc/IOCSetup";
import {Translation} from "../../http/protocol";
interface Props {
    akey? : string;
    locale?: string;
    onUpdate? : (t : Translation) => void;

    translation?: Translation;
}
export class EditTranslation extends React.Component<Props, { translation? : string, saving?: boolean, edit?: boolean}>{
    constructor(props : Props) {
        super(props);
        this.state = { translation : this.props.translation ? this.props.translation.value : "", saving : false, edit : false}
    }
    edit() {
        this.setState({ edit : true })
    }
    cancel () {
        this.setState( { edit : false })
    }
    saveTranslation() {
        if(this.state.saving) {
           return;
        }
        if(this.state.translation && this.state.translation.length > 0) {
            this.setState({ saving : true })
            getContainer().getTranslationsService().save({
                id : this.props.translation ? this.props.translation.id : undefined,
                key : this.props.akey,
                locale : this.props.locale,
                value : this.state.translation
            }).then( res => {
                this.setState({ edit : false, saving : false})
                if(this.props.onUpdate) {
                    this.props.onUpdate(res);

                } else {
                    this.setState({ saving : false});
                }
            })
        }
    }


    render() {
        if(this.props.translation && !this.state.edit) {
            return (
                <div className={"row"}>
                    <div className={"col-10"}>
                        {this.props.translation.value}
                    </div>
                    <div className={"col-2"}>
                        <i className={"fa fa-pen"} onClick={()=>this.edit()}></i>
                    </div>
                </div>

            )
        }
        return (
            <div className={"form-group form-inline"}>
                <input type={"text"} disabled={this.state.saving} className={"form-control col-8"} value={this.state.translation} onChange={(e)=> this.setState({ translation : e.target.value})}/>
                <a  className={"btn btn-primary col-1"} onClick={()=>this.saveTranslation()}><i className={"fa fa-save"}></i></a>
                {this.props.translation && <a href="/#" className={"btn btn-secondary col-1"} onClick={(e:any)=> { e.preventDefault(); this.cancel();}}><i className={"fa fa-times"}></i></a>}
            </div>
        )
    }
}